import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import oneNotificationBackground from './assets/one-mobile-notification.webp';
import Context from 'managers/Context';
import './styles.scss';

const PREVIEW_VARIANTS = {
    oneNotification: {
        backgroundImage: oneNotificationBackground,
        width: 506,
        height: 276,
    },
};

const SenderPreviewMobile = memo(
    ({
        title = 'Inbox',
        name,
        message = 'Message subject...',
        previewText = 'Preview text',
        variant = 'oneNotification',
    }) => {
        const currentTime = useMemo(() => Context.utilsFormats.getNowMoment('HH:mm'), []);

        const selectedVariant = useMemo(() => {
            return PREVIEW_VARIANTS[variant] || PREVIEW_VARIANTS.oneNotification;
        }, [variant]);
        const componentStyle = useMemo(() => {
            const width = selectedVariant.width || 390;
            const height = selectedVariant.height || 268;

            return {
                backgroundImage: `url(${selectedVariant.backgroundImage})`,
                aspectRatio: `${width} / ${height}`,
            };
        }, [selectedVariant]);

        return (
            <div className="sender-preview-mobile" style={componentStyle}>
                <div className="sender-preview-mobile__header">{title}</div>

                <div className="sender-preview-mobile__notification">
                    <div className="sender-preview-mobile__line sender-preview-mobile__line--title">
                        {name}
                    </div>
                    <div className="sender-preview-mobile__line sender-preview-mobile__line--time">
                        {currentTime}
                    </div>
                    <div className="sender-preview-mobile__line sender-preview-mobile__line--message">
                        {message}
                    </div>
                    <div className="sender-preview-mobile__line sender-preview-mobile__line--preview">
                        {previewText}
                    </div>
                </div>
            </div>
        );
    },
);

SenderPreviewMobile.displayName = 'SenderPreviewMobile';

SenderPreviewMobile.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    message: PropTypes.string,
    previewText: PropTypes.string,
    variant: PropTypes.oneOf(Object.keys(PREVIEW_VARIANTS)),
};

export default SenderPreviewMobile;
